module.exports = __webpack_public_path__ + "burkina-faso.svg?3f544e007bec46b8f5427d4845575bdd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/burkina-faso.svg
// module id = 123
// module chunks = 10